import PageLayout from "@common/Page";
import {
  FDF_US,
  FDF_WORLDWIDE,
  GLOBAL_CONSULTATION,
} from "@features/productInsights/data/activeTabs";
import { useFetchProductsQuery } from "@store/master";
import {
  getCurrentYearAndMonth,
  getMonthList,
  getYearList,
} from "@utils/helpers";
import { OTHER_INSIGHTS_TABS } from "constant/tabs";
import { useState } from "react";

const currentYearAndMonth = getCurrentYearAndMonth();
export default function OtherInsights() {
  const [year, setYear] = useState(currentYearAndMonth.year);
  const [month, setMonth] = useState(currentYearAndMonth.month);
  const [product, setProduct] = useState(null);
  const { data } = useFetchProductsQuery({ all: true });

  return (
    <PageLayout
      tabs={OTHER_INSIGHTS_TABS}
      title={"Other Insights"}
      onMonthChange={setMonth}
      month={month}
      onProductChange={setProduct}
      product={product}
      onYearChange={setYear}
      year={year}
      monthOptions={getMonthList()}
      yearOptions={getYearList()}
      productOptions={
        data?.data?.length
          ? data?.data.map((product) => ({
              label: product.name,
              value: product.name,
            }))
          : []
      }
      drawerInputsToShow={["year", "month", "product"]}
      filtersToShow={["year", "month"]}
      useDefaultSheetNames={true}
      fetchProductsWiseData={true} // will fetch show products on contents section - true means month
      uploadUrls={{
        global_consumption: "clean-the-global-consumption-raw-data",
        fdf_us_approvals: "clean-the-fdf-us-raw-data",
        fdf_worldwide: "clean-the-fdf-worldwide-raw-data",
      }}
      saveAndGenerateUrls={{
        global_consumption: "save-and-generate-global-consumption-data",
        fdf_us_approvals: "save-and-generate-fdf-us-data",
        fdf_worldwide: "save-and-generate-fdf-worldwide-data",
      }}
      redirectUrl="other_insights"
      fetchRawAndFinalFileUrls={{
        global_consumption: {
          raw: "download-global-consumption-raw-file",
          final: "download-global-consumption-final-file",
        },
        fdf_us_approvals: {
          raw: "download-fdf-us-raw-file",
          final: "download-fdf-us-final-file",
        },
        fdf_worldwide: {
          raw: "download-fdf-worldwide-raw-file",
          final: "download-fdf-worldwide-final-file",
        },
      }}
      subTypeId={{
        global_consumption: GLOBAL_CONSULTATION,
        fdf_us_approvals: FDF_US,
        fdf_worldwide: FDF_WORLDWIDE,
      }}
      sectionProductsTypes={{
        global_consumption: "global-consumption",
        fdf_us_approvals: "fdf-us",
        fdf_worldwide: "fdf-worldwide",
      }}
      sectionMonthsTypes={{}}
      sectionTypeValues={{
        global_consumption: "GlobalConsumption",
        fdf_us_approvals: "FdfUsApproval",
        fdf_worldwide: "FdfWorldwideApproval",
      }}
      previewSelectInputFields={{}}
      previewLockInputFields={{}}
    />
  );
}
